import type { FaireProductEntity } from "@faire/playground-entity-db/entity_types/product";
import { getEntityByToken } from "../get_entity";

export const getCompassProductEntity = (
  token: string
): FaireProductEntity | undefined => getEntityByToken(token, "product");
